import React from "react";

import { MdAutoAwesome } from "react-icons/md";
import { useTranslation } from "react-i18next";

/**
 * The way back to the Modern view while the Classic invoice is open.
 *
 * It floats rather than living inside the invoice because the Classic view is
 * the REAL production <InvoiceModal/>, and putting a control inside it would
 * mean editing a live billing component. This sits above the MUI Modal
 * (z-index 1300) and is rendered by whichever page owns the view state.
 *
 * Bottom-centre, because the classic invoice's own action row is along its top
 * edge and a switcher there would collide with Invoice / Label / Close.
 *
 * `disabled` while a Classic save is still in flight. Sitting above the modal
 * means it stays clickable over Classic's own upload / confirm overlays, and
 * switching mid-save unmounted the Classic component (losing its result
 * snackbar) while the Modern view fetched a copy from before the write landed.
 */
const ViewSwitchFab = ({ onSwitch, disabled = false }) => {
  const { t } = useTranslation("admin");
  return (
  <button
    type="button"
    onClick={onSwitch}
    disabled={disabled}
    title={
      disabled
        ? t("invoice.saveInProgress")
        : undefined
    }
    style={{ zIndex: 1400 }}
    className={`fixed bottom-5 left-1/2 flex -translate-x-1/2 items-center gap-2 rounded-full border border-state-purple-border bg-state-purple-bg px-4 py-2 font-manrope text-[11.5px] font-semibold text-state-purple-text shadow-ui-md focus-visible:outline focus-visible:outline-2 focus-visible:outline-brand ${
      disabled
        ? "cursor-not-allowed opacity-60"
        : "hover:bg-state-purple-solid hover:text-brand-contrast"
    }`}
  >
    <MdAutoAwesome className="h-4 w-4" />
    {disabled ? t("invoice.savingSwitchWhenDone") : t("invoice.switchToTheNewDesign")}
    {/* Explicit colour: without it the badge inherits the button's white
        hover label (hover:text-brand-contrast) while keeping its own
        bg-ui-surface, and in light mode the word vanishes on hover. */}
    <span className="rounded border border-state-purple-border bg-ui-surface px-1.5 py-px font-manrope text-[9px] font-bold uppercase tracking-[0.04em] text-state-purple-text">
      {t("invoice.beta")}
    </span>
  </button>
);
};

export default ViewSwitchFab;
